common.View.create('canvas.blocks.custom.video.Block', {
    onDOMLoad() {
        this.initPlayButton();
    },

    initPlayButton() {
        let video = this.element.find('video');
        let videoEl = video[0];
        let playButton = this.element.find('#playButton');

        if (!video || !videoEl) {
            return;
        }

        playButton.on('click', () => {
            if (videoEl.paused !== true) {
                return;
            }

            this.hidePlayButton();

            videoEl.play();
        });

        setInterval(() => {
            videoEl.paused === true ? this.showPlayButton() : this.hidePlayButton();
        }, 100);
    },

    showPlayButton() {
        let playButton = this.element.find('#playButton');
        playButton.addClass('pointer-events-auto');
        playButton.removeClass('opacity-0 pointer-events-none');
    },

    hidePlayButton() {
        let playButton = this.element.find('#playButton');
        playButton.removeClass('pointer-events-auto');
        playButton.addClass('opacity-0 pointer-events-none');
    },
});
